<template>
	<div data-tour-scope="coupons">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<!-- solo se aperta da un'altra pagina (es. consigli della scheda prodotto) -->
							<v-btn v-if="ret" icon class="mr-1" :title="ret.label" @click="back"><v-icon>mdi-arrow-left</v-icon></v-btn>
							<v-toolbar-title> {{ $vuetify.lang.t('$vuetify.front.ecommerce.coupon') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi regola coupon" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="coupon-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name || item.prefix || 'Regola coupon'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-btn small icon color="primary" data-tour="expand" :title="aperto(item) ? 'Chiudi' : 'Come funziona'" @click="apri(item)">
														<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="showItem(item)">
																<v-list-item-title class="size9">Codici</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center flex-wrap mb-2">
														<v-icon small color="primary" class="mr-1">{{ evento(item.event).icona }}</v-icon>
														<span class="font-weight-medium mr-2">{{ evento(item.event).label }}</span>
														<v-chip v-if="item.prefix" x-small label outlined color="primary" class="cp-prefix">{{ item.prefix }}</v-chip>
													</div>
												</template>
												<div class="d-flex align-center justify-space-between" data-tour="switch">
													<span class="card-label">Attivo</span>
													<v-switch v-model="item.active" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
												<CouponDetail v-if="aperto(item)" :item="item" class="mt-2" @edit="editItem(item)" @codes="showItem(item)" @delete="deleteItem(item)" />
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr :key="item._id">
											<td class="pl-1 pr-0 text-no-wrap" style="width: 76px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9">Modifica</v-list-item-title>
														</v-list-item>
														<v-list-item link @click="showItem(item)">
															<v-list-item-title class="size9">Codici</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
															<v-list-item-title class="size9">Elimina</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
												<v-btn small icon color="primary" data-tour="expand" :title="aperto(item) ? 'Chiudi' : 'Come funziona'" @click="apri(item)">
													<v-icon>{{ aperto(item) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<div class="font-weight-medium">{{ item.name || '—' }}</div>
												<v-chip v-if="item.prefix" x-small label outlined color="primary" class="cp-prefix mt-1">{{ item.prefix }}</v-chip>
											</td>
											<td>
												<div class="d-flex align-center">
													<v-icon small color="primary" class="mr-2">{{ evento(item.event).icona }}</v-icon>
													<span>{{ evento(item.event).label }}</span>
												</div>
												<div class="cp-sub">{{ item.utility === 'AUTOMATION' ? 'Automazione' : 'Coupon' }}</div>
											</td>
											<td data-tour="discount">
												<div class="cp-discount">{{ sconto(item) }}</div>
												<div v-if="soglia(item)" class="cp-sub">{{ soglia(item) }}</div>
											</td>
											<td class="cp-sub cp-validity">{{ validita(item) }}</td>
											<td data-tour="switch"><v-switch v-model="item.active" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch></td>
										</tr>
										<tr v-if="aperto(item)" :key="item._id + '-detail'" class="cp-expanded">
											<td :colspan="headers.length" class="py-3">
												<CouponDetail :item="item" @edit="editItem(item)" @codes="showItem(item)" @delete="deleteItem(item)" />
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando la regola non potrai più ripristinarla e non nasceranno più codici da lei.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createCouponsTourSteps, stopCouponsTour } from './coupons-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import CouponDetail from '@/components/ecommerce/coupon/CouponDetail.vue';
import { evento, sconto, soglia, validita } from '@/components/ecommerce/coupon/formato';
import { listRouteState } from '@/components/core/list/listRouteState';
import { returnInfo, goBackWithResult } from '@/components/core/pageReturn';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Coupons',
	// pagina, righe e ordinamento stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createCouponsTourSteps(), { onStop: stopCouponsTour }) };
	},
	components: {
		TourOverlay,
		KeyValueCard,
		CouponDetail,
	},
	data() {
		return {
			ret: returnInfo(this.$route),
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: { sortBy: ['created_at'], sortDesc: [true], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			total: 0,
			headers: [
				// colonna del menu a tre puntini e del dettaglio: non si ordina
				{ text: '', value: '', sortable: false },
				{ text: 'Nome', value: 'name' },
				{ text: 'Evento', value: 'event' },
				{ text: 'Sconto', value: 'discount' },
				{ text: 'Validità', value: 'start_at' },
				{ text: 'Attivo', value: 'active' },
			],
			// regole con il dettaglio aperto (+)
			aperti: [],
			dialogconfirm: false,
			daEliminare: null,
		};
	},
	created() {
		this.listLoad();
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getItems: 'coupon/getItems',
		}),
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		back() {
			goBackWithResult(this.$router, this.ret, '', null);
		},
		...mapActions({
			fetchItems: 'coupon/asyncFetchData',
			destroyData: 'coupon/destroyData',
			delete: 'coupon/deleteItem',
			setUpdateStatusItem: 'coupon/setUpdateStatusItem',
		}),
		// coppie chiave/valore della card su telefono: sconto e validita' in evidenza
		campiCard(item) {
			return [
				{ label: 'Sconto', value: [sconto(item), soglia(item)].filter(Boolean).join(' '), strong: true },
				{ label: 'Validità', value: validita(item) },
				{ label: 'Utilizzo', value: item.utility === 'AUTOMATION' ? 'Automazione' : 'Coupon' },
			];
		},
		evento,
		sconto,
		soglia,
		validita,
		aperto(item) {
			return this.aperti.includes(item._id);
		},
		apri(item) {
			this.aperti = this.aperto(item) ? this.aperti.filter(id => id !== item._id) : [...this.aperti, item._id];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 5000, text };
		},
		changeStatus(item) {
			this.setPreload(true);
			this.setUpdateStatusItem({ _id: item._id, active: item.active })
				.then(() => this.getDataFromApi())
				.then(() => this.notifica('success', 'Update successfully'))
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		// inserimento e modifica sono pagine: la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.$router.push(`/ecommerce/coupon/${item._id}`);
		},
		createItem() {
			this.$router.push('/ecommerce/coupon/new');
		},
		// i codici generati dalla regola stanno nella loro pagina, con l'_id della regola nell'URL
		showItem(item) {
			this.$router.push(`/ecommerce/coupon/${item._id}/codes`);
		},
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.daEliminare) return;
			this.setPreload(true);
			this.delete(this.daEliminare)
				.then(() => this.getDataFromApi())
				.then(() => this.notifica('success', 'Operazione effettuata con successo'))
				.catch(error => console.log(error))
				.finally(() => {
					this.daEliminare = null;
					this.setPreload(false);
				});
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>


<style scoped>
.cp-prefix {
	font-family: monospace;
}
.cp-sub {
	font-size: 12px;
	color: #5f6b7a;
}
.cp-discount {
	font-weight: 700;
	color: #01579b;
	white-space: nowrap;
}
.cp-validity {
	max-width: 260px;
}
.cp-expanded,
.cp-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.coupon-cards,
.coupon-cards tr {
	display: block;
	width: 100%;
}
.coupon-cards tr,
.coupon-cards tr:hover {
	background: transparent !important;
}
.coupon-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.coupon-cards tr:first-child td {
	padding-top: 12px !important;
}
.coupon-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.coupon-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* blocchi referenze/opzioni dentro la card */
.ref-line {
	background: #f7f8fa;
	border-radius: 6px;
	padding: 8px 10px;
	font-size: 14px;
}
.ref-kv {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	color: rgba(0, 0, 0, 0.6);
}
.ref-kv span:last-child {
	color: rgba(0, 0, 0, 0.87);
	text-align: right;
	word-break: break-word;
}
</style>
